import { createVehicle } from './createVehicle';
import { inquiries } from './inquiries';
import { modals } from './modals';
import { nav } from './nav';


createVehicle.init();
inquiries.init();
modals.init();
nav.init();